// Exact-match alias target for "@material-ui/icons" (see resolve.alias in
// webpack.common.js). Compiled @passportinc packages require the full icon
// barrel (~5,270 modules); this shim narrows the bundle to the icons they
// actually reference. The guard test src/tests/materialUiIconsBarrelImport.test.js
// re-derives this list from node_modules on every run and fails on drift.
module.exports = {
	__esModule: true,
	AttachFile: require("@material-ui/icons/AttachFile").default,
	Audiotrack: require("@material-ui/icons/Audiotrack").default,
	Check: require("@material-ui/icons/Check").default,
	ChevronLeft: require("@material-ui/icons/ChevronLeft").default,
	ChevronRight: require("@material-ui/icons/ChevronRight").default,
	Close: require("@material-ui/icons/Close").default,
	CloudDownload: require("@material-ui/icons/CloudDownload").default,
	CloudUpload: require("@material-ui/icons/CloudUpload").default,
	Collections: require("@material-ui/icons/Collections").default,
	DashboardRounded: require("@material-ui/icons/DashboardRounded").default,
	DeleteForever: require("@material-ui/icons/DeleteForever").default,
	Email: require("@material-ui/icons/Email").default,
	Event: require("@material-ui/icons/Event").default,
	ExpandMore: require("@material-ui/icons/ExpandMore").default,
	HighlightOff: require("@material-ui/icons/HighlightOff").default,
	Image: require("@material-ui/icons/Image").default,
	KeyboardArrowDown: require("@material-ui/icons/KeyboardArrowDown").default,
	KeyboardArrowUp: require("@material-ui/icons/KeyboardArrowUp").default,
	Link: require("@material-ui/icons/Link").default,
	Person: require("@material-ui/icons/Person").default,
	Phone: require("@material-ui/icons/Phone").default,
	PictureAsPdf: require("@material-ui/icons/PictureAsPdf").default,
	Search: require("@material-ui/icons/Search").default,
	TextFields: require("@material-ui/icons/TextFields").default,
	Today: require("@material-ui/icons/Today").default,
	Videocam: require("@material-ui/icons/Videocam").default,
	Visibility: require("@material-ui/icons/Visibility").default,
	Warning: require("@material-ui/icons/Warning").default,
};
